import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../styles';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  header_actions: {
    color: Colors.APP_COLOR_HIGHLIGHT(),
    background: 'white',
    border: '1px solid white',
    marginLeft: '.5rem',
    '&:hover': {
      background: 'white',
    },
  },
  sticky_bar: {
    position: 'sticky',
    top: 64,
    zIndex: 1190,
    [theme.breakpoints.down('sm')]: {
      top: 56,
    },
  },
  titleLayout: {
    padding: 20,
    backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
    color: 'white',
  },
  cardLayout: {
    marginBottom: 10,
  },
  back_button: {
    color: 'white',
    marginRight: '2rem',
  },
  subtitles: {
    padding: '1rem 12px',
  },
  subtitle2: {
    marginTop: '.5rem',
    fontWeight: 'normal',
    marginBottom: '.5rem',
  },
  card: {
    background: 'white',
    borderRadius: '.5rem',
    padding: '2rem 1rem',
    border: '1px solid lightgray',
  },
  services: {
    color: '#42a5f5 !important',
  },
  goods: {
    color: '#ffa726 !important',
  },
  errors: {
    color: 'firebrick',
    padding: '0 12px',
    fontWeight: 'bold',
  },
}));

export default useStyles;
